import { colors } from 'src/constants/colors';
import { TSvgIcon } from 'src/types/common.types';

const DiscoverIcon = ({ color = colors.neutral[600], ...rest }: TSvgIcon) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" {...rest}>
      <path d="M16.8 1.09951L6.86997 3.58951C5.41997 3.94951 3.94997 5.41951 3.58997 6.86951L1.09997 16.7995C0.34997 19.7995 2.18997 21.6495 5.19997 20.8995L15.13 18.4195C16.57 18.0595 18.05 16.5795 18.41 15.1395L20.9 5.19951C21.65 2.19951 19.8 0.349513 16.8 1.09951Z" stroke="#535353" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 14.4995C12.933 14.4995 14.5 12.9325 14.5 10.9995C14.5 9.06652 12.933 7.49951 11 7.49951C9.06697 7.49951 7.49997 9.06652 7.49997 10.9995C7.49997 12.9325 9.06697 14.4995 11 14.4995Z" stroke="#535353" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default DiscoverIcon;
